_state$velocityCheck